import { useEffect, useImperativeHandle, useState } from 'react';
import { PilotAssignmentErrorCodes } from '../../services/DispatcherActions';
import {
    FieldWrapper,
} from "@progress/kendo-react-form";
import { Label } from '../../../../components/layout/Label';
import { DateTimePicker } from '../../../../components/layout/date-time/DateTimePicker';
import { toDateObject } from '../../../../components/helpers/DateTimeHelpers';
import { useHasEditableChanged } from '../hooks/usePilotAssignmentStore';

export const TimeArrivalCard = (
    {
        ref,
        initializeIsDirty,
        onArrivalTimeChanged,
        assignmentService
    }) => {

    useImperativeHandle(ref, () => ({
        onPilotageChanged() {
            initialize();
        },
        onValidationChanged(codeStrings) {
            setHasValidationError(codeStrings.includes(PilotAssignmentErrorCodes.PilotArrivalTimeIsMissing));
        }
    }));

    const [arrivalTime, setArrivalTime] = useState(null);
    const [hasValidationError, setHasValidationError] = useState(false);
    const [isEditable, setIsEditable] = useState(false);

    const hasEditableChanged = useHasEditableChanged();

    useEffect(() => {
        initialize();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if(!hasEditableChanged) return;
        initialize();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hasEditableChanged]);

    return (
        <FieldWrapper>
            <Label hasValidationError={hasValidationError}>
                Oppm&oslash;te:
            </Label>
            <div className="k-form-field-wrap">
                <DateTimePicker
                    disabled={!isEditable}
                    hasValidationError={hasValidationError}
                    title="Velg oppm&oslash;te tid"
                    value={arrivalTime}
                    onChange={onChangedAsync} />
            </div>
        </FieldWrapper>
    )

    function initialize() {
        const pilotAssignment = assignmentService.assignment;

        setArrivalTime(toDateObject(pilotAssignment.arrivalTime));
        setIsEditable(assignmentService.isEditable);
    }

    async function onChangedAsync(e) {
        setArrivalTime(e);
        await assignmentService.onPilotArrivalTimeAsync(e);
        onArrivalTimeChanged();
        initializeIsDirty();
    }
}
